import React, { useEffect, useState } from 'react';
import './UsersList.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTrashCan, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';


const config=require( '../../config.js');

function UsersReview() {
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();

    const fetchUsers = async () => {
        try {
            const response = await fetch(config.env.API_BASE_URL + '/api/users/request', {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                const data = await response.json();
                setUsers(data);
            } else {
                console.error('Failed to fetch users');
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsers(); 
    }, []);

    const handleEnableUser = async (id) => {
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/users/${id}/enable`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                fetchUsers()
                alert('User enabled successfully');
            } else {
                console.error('Failed to enable user');
            }
        } catch (error) {
            console.error('Error enable user:', error);
        }
    };

    const handleDisableUser = async (id) => {
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/users/${id}/disable`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                fetchUsers()
                alert('User disabled successfully');
            } else {
                console.error('Failed to disable user');
            }
        } catch (error) {
            console.error('Error disable user:', error);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/users/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });
            if (response.ok) {
                setUsers(users.filter(user => user._id !== id));
                alert('User deleted successfully');
            } else {
                console.error('Failed to delete user');
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        }
    };

    return (
        <>
            <div className='mt-5 Crud-main-container container'>
                <table className="table Crud-main container">
                    <thead>
                        <tr className="Crud-thead-wrapper">
                            <th scope="col" className='text-start'>Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Type</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users
                            .slice()
                            .map((user) => (
                                <tr key={user._id}>
                                    <td className='w-50 text-start'>{user.name}</td>
                                    <td>{user.email}</td>
                                    <td>{user.role}</td>
                                    <td>
                                        <FontAwesomeIcon
                                            onClick={() => {
                                                if(window.confirm('Are you sure you want to disable this user?')) {
                                                    handleDisableUser(user._id)
                                                }
                                            }}
                                            className='icon'
                                            icon={faXmark}
                                        /> 
                                        <FontAwesomeIcon
                                            onClick={() => {
                                                if(window.confirm('Are you sure you want to enable this user?')) {
                                                    handleEnableUser(user._id)
                                                }
                                            }}
                                            className='icon'
                                            icon={faCheck}
                                        /> 
                                        <FontAwesomeIcon
                                            onClick={() => {
                                                if (window.confirm('Are you sure you want to delete this user?')) {
                                                    handleDelete(user._id);
                                                }
                                            }}
                                            className='icon trash'
                                            icon={faTrashCan}
                                        />
                                    </td>
                                </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default UsersReview;
